import React, { useState, useEffect } from 'react';
import NuevaCampaña from './NuevaCampaña';
import CreadorPlantillas from './CreadorPlantillas';
import CampañasCorreos from './CampañasCorreos';
import { useConfiguracion } from '../../../metodos/ConfiguracionContext';
import { obtenerNombreEmpresaReal } from '../../../config/unificacion';
import LogCorreos from './LogCorreos';

const DashCorreos = () => {

  const [activeTab, setActiveTab] = useState('campanas');
  const { configuracion } = useConfiguracion();
  const nombreEmpresa = obtenerNombreEmpresaReal(configuracion.nombreEmpresa);


  return (
    <div className="p-6 bg-gray-50 min-h-screen text-gray-800 font-sans">
      
      {/* HEADER */}
      <div className="flex justify-between items-center mb-8 border-b pb-4 border-gray-200">
        <div>
          <h1 className="text-3xl font-bold text-gray-900">Módulo de Email Marketing</h1>
          <p className="text-sm text-gray-500 mt-1">Gestiona tus campañas, segmenta destinatarios y analiza el impacto.</p>
        </div>
        <div className="bg-blue-100 text-blue-800 text-xs font-semibold px-3 py-1.5 rounded-full uppercase tracking-wider">
          {nombreEmpresa}
        </div>
      </div>

      {/* MENÚ DE PESTAÑAS (TABS) */}
      <div className="flex flex-wrap gap-1 border-b border-gray-200 mb-8 pb-px">
        
        {/* PESTAÑA: CAMPAÑAS */}
        <button 
          onClick={() => setActiveTab('campanas')}
          className={`flex items-center space-x-2 py-3 px-5 text-xs font-bold uppercase tracking-wider transition-all border-b-2 -mb-px outline-none ${
            activeTab === 'campanas' 
              ? 'border-blue-600 text-blue-600 font-extrabold' 
              : 'border-transparent text-gray-400 hover:text-gray-600 hover:border-gray-300'
          }`}
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
          </svg>
          <span>Campañas</span>
        </button>

        {/* PESTAÑA: NUEVA CAMPAÑA */}
        <button 
          onClick={() => setActiveTab('nueva')}
          className={`flex items-center space-x-2 py-3 px-5 text-xs font-bold uppercase tracking-wider transition-all border-b-2 -mb-px outline-none ${
            activeTab === 'nueva' 
              ? 'border-emerald-600 text-emerald-600 font-extrabold' 
              : 'border-transparent text-gray-400 hover:text-gray-600 hover:border-gray-300'
          }`}
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M12 4v16m8-8H4"></path>
          </svg>
          <span className="whitespace-nowrap">Nueva Campaña</span>
        </button>

        {/* PESTAÑA: BIBLIOTECA DE PLANTILLAS */}
        <button 
          onClick={() => setActiveTab('biblioteca')}
          className={`flex items-center space-x-2 py-3 px-5 text-xs font-bold uppercase tracking-wider transition-all border-b-2 -mb-px outline-none ${
            activeTab === 'biblioteca' 
              ? 'border-purple-600 text-purple-600 font-extrabold' 
              : 'border-transparent text-gray-400 hover:text-gray-600 hover:border-gray-300'
          }`}
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
          </svg>
          <span className="whitespace-nowrap">Biblioteca de Plantillas</span>
        </button>

        {/* LOGS CORREOS */}
        <button 
          onClick={() => setActiveTab('logs')}
          className={`flex items-center space-x-2 py-3 px-5 text-xs font-bold uppercase tracking-wider transition-all border-b-2 -mb-px outline-none ${
            activeTab === 'biblioteca' 
              ? 'border-purple-600 text-purple-600 font-extrabold' 
              : 'border-transparent text-gray-400 hover:text-gray-600 hover:border-gray-300'
          }`}
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
          </svg>
          <span className="whitespace-nowrap">LOGS</span>
        </button>

      </div>

      {/* SECCIÓN 2: HISTORIAL DE CAMPAÑAS */}
      {activeTab === 'campanas' && (
        <CampañasCorreos />
      )}

      {/* SECCIÓN 3: CREADOR DE NUEVA CAMPAÑA */}
      {activeTab === 'nueva' && (
        <NuevaCampaña onCampanaCreada={() => setActiveTab('campanas')} />
      )}

      {activeTab === 'biblioteca' && (
        <CreadorPlantillas />
      )}

      {activeTab === 'logs' && (
        <LogCorreos />
      )}

    </div>
  );

};

export default DashCorreos;